import { Fragment, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { __MANAGEMENT_API_URL__ } from 'shell/constants/environment';
import FormInstitution from 'system/components/institution/form';
import { useHttpFetch } from 'shell/hooks/use-old-http-fetch';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonInstitutionCrumbs } from '../constants';
import { toast } from 'react-toastify';

const InstitutionNewPage = (): React.ReactElement => {
  const { post: insertInstitution } = useHttpFetch(`${__MANAGEMENT_API_URL__}/enti`);
  const navigate = useNavigate();
  const onSubmit = useCallback(
    (formValues) => {
      insertInstitution({
        codiceIstat: formValues.istat,
        numeroUfficiStatoCivile: formValues.officeNumber,
        nome: `Comune di ${formValues.name.description}`,
        sindaco: formValues.mayor || '',
        codFiscaleSindaco: formValues.mayorFiscalCode || '',
        provincia: formValues.province,
        note: formValues.lastUpdate,
        descrizioneDirezione: formValues.direction,
        key: {
          codice: formValues.code,
        },
      }).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/sistema/enti');
      });
    },
    [insertInstitution, navigate]
  );

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonInstitutionCrumbs, { name: 'Nuovo Ente' }]} />
      <FormInstitution
        title="Nuovo Ente"
        onOk={onSubmit}
        onCancel={() => {
          navigate('/sistema/enti');
        }}
      />
    </Fragment>
  );
};

InstitutionNewPage.displayName = 'Institution new page component';

export default InstitutionNewPage;
